import dynamic from 'next/dynamic';
import { AddToCalendarProps } from './AddToCalendarModal.types';

export const AddtoCalendarModal = dynamic<AddToCalendarProps>(() => import('./AddToCalendarModal'));
